import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'cpf'
})
export class CpfPipe implements PipeTransform {
	public transform(value: string): string {
		if (!value) {
			return value;
		}

		const cpf: string = value.replace(/\D/g, '');

		if (cpf.length !== 11) return value;

		return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
	}
}
